/**
*
* LogoLanding
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Svg from '../Svg';
import { HiddenH1 } from '../Typography';
import media from '../../style/mediainjector';


export const LogoBox = styled.div`
  width: ${(props) => (props.width ? props.width : '100%')};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : '400px')};
  margin: ${(props) => (props.margin ? props.margin : '0')};
`;


export const LogoWrapper = styled.div`
  ${({
    start, width: widthProp, height: heightProp, theme
  }) => {
    const {
      logo: {
        style: {
          height, startHeight, svgDisplay, svgHeight, startSvgHeight,
        },
      } = { style: {} },
    } = theme;

    let calculatedHeight = heightProp || height;
    let calculatedSvgHeight = heightProp || svgHeight;

    if (start) {
      calculatedHeight = startHeight;
      calculatedSvgHeight = startSvgHeight;
    }

    return css`
      height: ${calculatedHeight};
      width: ${widthProp};
      svg {
        display: ${svgDisplay};
        height: ${calculatedSvgHeight};
      }

      ${media.lt667`
        height: ${height};
        svg {
          height: ${svgHeight};
        }
      `}
    `;
  }}
`;


class Logo extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  render() {
    const {
      title,
      width,
      height,
      fill,
      maxWidth,
      margin,
      className,
      start,
      logoImage,
    } = this.props;

    return (
      <LogoWrapper start={start} height={height} width={width}>
        <LogoBox
          width={width}
          maxWidth={maxWidth}
          margin={margin}
          className={className}
        >
          <HiddenH1>{title}</HiddenH1>
          {logoImage && <Svg {...logoImage} fill={fill} height={logoImage.height} />}
        </LogoBox>
      </LogoWrapper>
    );
  }
}

Logo.propTypes = {
  logoImage: PropTypes.object,
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
  maxWidth: PropTypes.string,
  margin: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  start: PropTypes.number,
};

export default Logo;
